import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Form, Col, Tab, Tabs } from 'react-bootstrap';
import uuid from 'uuid/v1';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty, map } from 'lodash';
import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import methodPromise from '../../../modules/method-promise-wrapper';
import Projects from '../../../api/Projects/Projects';
import Videos from '../../../api/Videos/Videos';

import * as layerOps from '../../../api/Layers/layer-operations';

const LayerAnnotationsFields = ({
  projectList,
  layer,
  layerSubType,
  annotationLayerProperties,
  loadAnnotationLayerProperties,
  videoList
}) => {
  if (layerSubType === LAYER_SUBTYPES.ANNOTATIONS && !isEmpty(projectList)) {
    const allGeometries = [
      { name: 'Anotaciones', key: 'Point' },
      { name: 'Traza del video', key: 'LineString' }
    ];

    const initialProperties = isEmpty(annotationLayerProperties.project)
      ? layerOps.getAnnotationLayerProperties(layer)
      : annotationLayerProperties;

    const [videosFromProject, setVideosFromProject] = React.useState(videoList);
    const [annotationsFromVideos, setAnnotationsFromVideos] = React.useState([]);
    const initialGeometry = isEmpty(initialProperties.geometry)
      ? { name: 'Anotaciones', key: 'Point' }
      : initialProperties.geometry;
    const [geometry, setGeometry] = React.useState(initialGeometry);

    const [videoSelected, setVideoSelected] = React.useState(
      videoList.filter(objeto => initialProperties.videosId.includes(objeto._id))
    );
    const [annotationSelected, setAnnotationSelected] = React.useState([]);

    const [project, setProject] = React.useState(
      projectList.find(item => item._id === initialProperties.projectId)
    );

    const processVideos = async newVideoSelected => {
      try {
        const annotationsPromises = newVideoSelected.map(async element => {
          const promise = await methodPromise('annotations.annotationsFromVideo', element._id);
          return promise;
        });
        const nuevoArrayDeIDs = newVideoSelected.map(objeto => objeto._id);

        const newAnnotationsFromVideos = (await Promise.all(annotationsPromises)).flat();

        setAnnotationsFromVideos(newAnnotationsFromVideos);
        loadAnnotationLayerProperties({
          projectId: project._id,
          videosId: nuevoArrayDeIDs,
          annotationsId: [],
          geometry,
          geojsonAnnotations: {}
        });
      } catch (error) {
        console.error('Error al procesar videos:', error);
      }
    };

    const handleProject = async event => {
      const newProject = projectList.filter(element => element.name === event.target.value);
      setProject(newProject[0]);
      try {
        const newVideosFromProject = await methodPromise(
          'videos.videosFromProject',
          newProject[0]._id
        );
        setVideosFromProject(newVideosFromProject);
        setAnnotationSelected([]);
        setAnnotationsFromVideos([]);
        loadAnnotationLayerProperties({
          project: newProject[0]._id,
          geojsonAnnotations: {},
          videoSelected: [],
          annotationSelected: [],
          geometry
        });
      } catch (error) {
        Bert.alert('El proyecto no contiene videos', 'warning');
      }
    };

    const handleAnnotations = event => {
      let geojsonToDraw = [];
      const newAnnotationsId = map(event.target.form.annotationList.selectedOptions, 'value');
      const newAnnotationSelected = annotationsFromVideos.filter(item =>
        newAnnotationsId.includes(item._id)
      );
      setAnnotationSelected(newAnnotationSelected);

      if (!isEmpty(newAnnotationSelected)) {
        map(newAnnotationSelected, indexElement => {
          if (!isEmpty(indexElement.geoJSON)) {
            geojsonToDraw = [...geojsonToDraw, indexElement.geoJSON];
          }
        });
      }
      const nuevoArrayDeIDs = videoSelected.map(objeto => objeto._id);

      loadAnnotationLayerProperties({
        projectId: project._id,
        videosId: nuevoArrayDeIDs,
        annotationsId: newAnnotationsId,
        geometry,
        geojsonAnnotations: { type: 'FeatureCollection', features: geojsonToDraw }
      });
    };

    const handleTabChange = key => {
      let geojsonToDraw = [];
      const newGeometry = allGeometries.find(element => element.key === key);
      setGeometry(newGeometry);
      if (key === 'LineString') {
        map(videoSelected, element => {
          if (!isEmpty(element.track)) {
            geojsonToDraw = [...geojsonToDraw, element.track];
          }
        });
      } else if (key === 'Point') {
        processVideos(videoSelected);
      }
      setAnnotationSelected([]);
      const nuevoArrayDeIDs = videoSelected.map(objeto => objeto._id);
      loadAnnotationLayerProperties({
        projectId: project._id,
        videosId: nuevoArrayDeIDs,
        annotationsId: [],
        geometry: newGeometry,
        geojsonAnnotations: { type: 'FeatureCollection', features: geojsonToDraw }
      });
    };
    const handleVideos = event => {
      const videosName = map(event.target.form.videoList.selectedOptions, 'value');
      const newVideoSelected = videosFromProject.filter(objeto => videosName.includes(objeto.name));
      const nuevoArrayDeIDs = videosFromProject.map(objeto => objeto._id);

      setVideoSelected(newVideoSelected);
      let geojsonToDraw = [];

      if (newVideoSelected) {
        if (geometry.key === 'LineString') {
          map(newVideoSelected, element => {
            if (!isEmpty(element.track)) {
              geojsonToDraw = [...geojsonToDraw, element.track];
            }
          });
          loadAnnotationLayerProperties({
            projectId: project._id,
            videosId: nuevoArrayDeIDs,
            annotationsId: [],
            geometry,
            geojsonAnnotations: { type: 'FeatureCollection', features: geojsonToDraw }
          });
        } else if (geometry.key === 'Point') {
          processVideos(newVideoSelected);
        }
      }
    };

    React.useEffect(() => {
      const FunctionProeccess = async () => {
        try {
          const annotationsPromises = videoSelected.map(async element => {
            const promise = await methodPromise('annotations.annotationsFromVideo', element._id);
            return promise;
          });
          const newAnnotationsFromVideos = (await Promise.all(annotationsPromises)).flat();
          setAnnotationsFromVideos(newAnnotationsFromVideos);

          setAnnotationSelected(
            newAnnotationsFromVideos.filter(objeto =>
              initialProperties.annotationsId.includes(objeto._id)
            )
          );
        } catch (error) {
          Bert.alert('Error al procesar el proyecto o videos', 'warning');
          console.error('Error al procesar el proyecto o videos:', error);
        }
      };

      if (isEmpty(annotationLayerProperties.project)) {
        FunctionProeccess();
      }
    }, []);

    return (
      <>
        <Form.Row>
          <Form.Group as={Col} xs={12}>
            <Form.Label>Proyectos</Form.Label>
            <Form.Control as="select" value={project?.name} onChange={handleProject}>
              <option value="">Select a project</option>
              {projectList.map(({ name }) => (
                <option value={name} key={uuid()}>
                  {name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form.Row>
        {!isEmpty(project) && (
          <Form.Row>
            {isEmpty(videosFromProject) ? (
              <Alert key={uuid()} variant="warning">
                El proyecto {project.name} no contiene videos
              </Alert>
            ) : (
              <Col>
                <Form>
                  <Form.Row>
                    <Form.Label>Videos</Form.Label>
                    <Form.Control
                      as="select"
                      multiple
                      name="videoList"
                      value={videoSelected.map(video => video.name) || ''}
                      onChange={handleVideos}
                    >
                      {map(videosFromProject, attribute => (
                        <option value={attribute.name} key={attribute.name}>
                          {attribute.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Row>
                </Form>
              </Col>
            )}
          </Form.Row>
        )}
        {!isEmpty(project) && !isEmpty(videoSelected) && (
          <Form.Row>
            <Col>
              <Tabs
                id="fill-tab-example"
                className="mb-3"
                fill
                onSelect={handleTabChange}
                activeKey={geometry.key}
              >
                <Tab eventKey="Point" title="Anotaciones" key="Point">
                  {isEmpty(annotationsFromVideos) ? (
                    <Alert key={uuid()} variant="warning">
                      Los videos seleccionados no contienen anotaciones.
                    </Alert>
                  ) : (
                    <Form>
                      <Form.Row>
                        <Form.Control
                          as="select"
                          multiple
                          name="annotationList"
                          value={annotationSelected?.map(item => item._id)}
                          onChange={handleAnnotations}
                        >
                          {map(annotationsFromVideos, attribute => {
                            const videoName = videosFromProject.find(
                              item => item._id === attribute.geoJSON?.properties.video
                            );
                            return (
                              <option value={attribute._id} key={attribute._id}>
                                {attribute.geoJSON?.properties.template.name} - {videoName?.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Form.Row>
                    </Form>
                  )}
                </Tab>
                <Tab eventKey="LineString" title="Traza del video" key="LineString" />
              </Tabs>
            </Col>
          </Form.Row>
        )}
      </>
    );
  }
  return '';
};
LayerAnnotationsFields.defaultProps = {
  projectList: [],
  videoList: [],
  annotationLayerProperties: {}
};
LayerAnnotationsFields.propTypes = {
  projectList: PropTypes.array,
  layerSubType: PropTypes.string.isRequired,
  layer: PropTypes.object.isRequired,
  videoList: PropTypes.array,
  loadAnnotationLayerProperties: PropTypes.func.isRequired,
  annotationLayerProperties: PropTypes.object
};
export default withTracker(({ annotationLayerProperties, layer }) => {
  const projectQuery = { deleted: { $eq: 'no' } };
  const sortOptions = { sort: { name: 1 } };
  const projectsSub = Meteor.subscribe('projects');
  const initialProperties = isEmpty(annotationLayerProperties.project)
    ? layerOps.getAnnotationLayerProperties(layer)
    : false;

  let videosSub = null;
  if (initialProperties !== false && !isEmpty(initialProperties.projectId)) {
    videosSub = Meteor.subscribe('videos', initialProperties.projectId);
  }
  return {
    loading: !projectsSub.ready() && (!videosSub || !videosSub.ready()),
    projectList: Projects.find(projectQuery, sortOptions).fetch(),
    videoList: initialProperties !== false && Videos.find(projectQuery, sortOptions).fetch()
  };
})(LayerAnnotationsFields);
